/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createChargerDefinitionFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeUpdateChargerDefinitionCommand, type ChargerDefinition, type ProblemDetails, type UpdateChargerDefinitionCommand } from '../../models/index.js';
// @ts-ignore
import { AuditentriesRequestBuilderRequestsMetadata, type AuditentriesRequestBuilder } from './auditentries/index.js';
// @ts-ignore
import { ConformityStatementRequestBuilderRequestsMetadata, type ConformityStatementRequestBuilder } from './conformityStatement/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargerdefinitions/{id}
 */
export interface ChargerdefinitionsItemRequestBuilder extends BaseRequestBuilder<ChargerdefinitionsItemRequestBuilder> {
    /**
     * The auditentries property
     */
    get auditentries(): AuditentriesRequestBuilder;
    /**
     * The conformityStatement property
     */
    get conformityStatement(): ConformityStatementRequestBuilder;
    /**
     * DeleteChargerDefinition
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     delete(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * GetChargerDefinition
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ChargerDefinition>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ChargerDefinition | undefined>;
    /**
     * UpdateChargerDefinition
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     put(body: UpdateChargerDefinitionCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * DeleteChargerDefinition
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * GetChargerDefinition
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * UpdateChargerDefinition
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateChargerDefinitionCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ChargerdefinitionsItemRequestBuilderUriTemplate = "{+baseurl}/chargerdefinitions/{id}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ChargerdefinitionsItemRequestBuilderNavigationMetadata: Record<Exclude<keyof ChargerdefinitionsItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    auditentries: {
        requestsMetadata: AuditentriesRequestBuilderRequestsMetadata,
    },
    conformityStatement: {
        requestsMetadata: ConformityStatementRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ChargerdefinitionsItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: ChargerdefinitionsItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: ChargerdefinitionsItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createChargerDefinitionFromDiscriminatorValue,
    },
    put: {
        uriTemplate: ChargerdefinitionsItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateChargerDefinitionCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
